const config = {
  AUTH_BASE_URL: 'https://skill-tracker-backend-8m9o.onrender.com',
};

export default config;
